import { Component } from '@angular/core';
import { RouterOutlet, RouterLink } from '@angular/router';
import { MatListModule } from '@angular/material/list';

@Component({
  selector: 'app-sample-pages',
  standalone: true,
  imports: [RouterOutlet, MatListModule, RouterLink],
  templateUrl: './sample-pages.component.html',
  styleUrl: './sample-pages.component.css',
})
export class SamplePagesComponent {
  constructor() {}
}
